<div id="footerComponent" class="main-footer text-center">
  {{ printVersion() }} <b>{{ currentYear }}</b> © Powered by <b>Wetechnology</b>.
</div>
